module.exports = __webpack_public_path__ + "img/pro_two_6.12459a4f.jpg";